import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { COOKIE_KEY } from '@shared/constants';

function generateRandomId() {
  return Math.random().toString(36).substring(2, 12);
}

export function setDeviceId() {
  let existingDeviceId = Cookies.get(COOKIE_KEY.deviceId);
  if (!existingDeviceId) {
    existingDeviceId = generateRandomId();
    Cookies.set(COOKIE_KEY.deviceId, existingDeviceId, {
      path: '/',
      secure: true,
      expires: 365,
    });
  }
}

export function useDeviceId() {
  useEffect(setDeviceId, []);
}
